import React, { PropTypes } from 'react';
import { Dialog } from 'material-ui';

const GenericDialog = props => {
  const {
    dialogTitle,
    actions,
    subContent,
    hiddenErrorChecking,
    mainContent,
  } = props;

  return (
    <div>
      <Dialog
        title={dialogTitle}
        actions={actions}
        modal
        open
      >
        <div>
          {mainContent}
          {subContent}
        </div>
      </Dialog>
      {hiddenErrorChecking}
    </div>
  );
};

GenericDialog.propTypes = {
  dialogTitle: PropTypes.string,
  actions: PropTypes.array,
  subContent: PropTypes.object,
  hiddenErrorChecking: PropTypes.object,
  mainContent: PropTypes.object,
};

export default GenericDialog;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/external-links/generic-dialog.jsx